import React from "react";
import { Helmet } from "react-helmet-async";
import { BRAND_ASSETS } from "../utils/brandAssets";

const SeoHead = ({
  title,
  description,
  keywords,
  canonical,
  robots = "index, follow",
  jsonLd,
}) => (
  <Helmet>
    <title>{title}</title>
    {description ? <meta name="description" content={description} /> : null}
    {keywords ? <meta name="keywords" content={keywords} /> : null}
    <meta name="author" content="James Carvallyo" />
    <meta name="robots" content={robots} />
    {canonical ? <link rel="canonical" href={canonical} /> : null}

    <meta property="og:type" content="website" />
    {canonical ? <meta property="og:url" content={canonical} /> : null}
    <meta property="og:title" content={title} />
    {description ? (
      <meta property="og:description" content={description} />
    ) : null}
    <meta property="og:image" content={BRAND_ASSETS.ogImageAbsolute} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:site_name" content="Stats.Fan" />

    <meta property="twitter:card" content="summary_large_image" />
    {canonical ? <meta property="twitter:url" content={canonical} /> : null}
    <meta property="twitter:title" content={title} />
    {description ? (
      <meta property="twitter:description" content={description} />
    ) : null}
    <meta property="twitter:image" content={BRAND_ASSETS.ogImageAbsolute} />

    {jsonLd ? (
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    ) : null}
  </Helmet>
);

export default SeoHead;
